export const fetchGeoLocation = async () => {
    const fallback = {
        country_name: "United Arab Emirates",
        country_code: "AE",
    };

    try {
        const endpoint = `${process.env.BACKEND_URL}api/v1/getLocation/?key=${process.env.IP2LOCATION_API_KEY}`;
        const response = await fetch(endpoint);
        if (response.ok) {
            return await response.json();
        }
    } catch (error) {
        console.error("Geo fetch failed:", error);
    }

    return fallback;
};
